<template>

<nav class="level" style="margin-bottom: 10px;">

    <div class="level-left">
        <div class="level-item" style="margin-right: 0px !important; padding-left: 10px; padding-right: 0px !important;">
            <b-field>
                <b-switch type="is-info" true-value="1" false-value="0" v-model="behaviorData.status" @input="updateStatus()"></b-switch>
            </b-field>
        </div>
        <div class="level-item">
            <b-input type="text" placeholder="Item Name" v-model="behaviorData.name" style="width: 350px;" />
        </div>
        <div class="level-item">
            <b-input type="number" placeholder="Points, e.g.: 10" v-model="behaviorData.points" style="width: 80px;" />
        </div>
        <div class="level-item">
            <b-select id="newDataType" name="newDataType" v-model="newDataType" style="width: 300px;">
                <option value="1">Normal</option>
                <option value="2">Attendance</option>
                <option value="4">Parent (only appear in Parent app)</option>
                <option value="5">Subject Attendance</option>
            </b-select>
        </div>
        <div class="level-item">
            1 to <b-input type="number" v-model="behaviorData.scaleLimit" v-show="(behaviorData.dataType == 1 || behaviorData.dataType == 4 || behaviorData.dataType == 5)" style="width: 80px; margin-left: 10px;" />
        </div>
    </div>
    <div class="level-right">
        <div class="level-item" style="margin-right: 3px;"><b-button type="is-primary" v-on:click="updateData(behaviorData)" style="padding-left: 35px; padding-right: 35px;">SAVE</b-button></div>
        <div class="level-item" style="margin-right: 3px;"><b-button type="is-warning" @click="isComponentModalActive = true">MORE</b-button></div>
        <!-- <div class="level-item"><b-button type="is-danger" v-on:click="deleteData(behaviorData)" style="padding: 2px;">REMOVE</b-button></div> -->
        <div class="level-item"><b-button type="is-danger is-light" v-on:click="deleteData(behaviorData)" icon-right="trash-alt"/></div>
    </div>

    <b-modal
        v-model="isComponentModalActive"
        trap-focus
        :destroy-on-hide="false"
        :width=1000
        aria-role="dialog"
        aria-label="More Options"
        aria-modal>
            
        <div class="modalContents">
            <div class="columns">
                <div class="column is-full">
                    <nav class="level">
                        <div class="level-left">
                            <div class="level-item"><h3>Additional Configuration</h3></div>
                        </div>
                        <div class="level-right">
                            <div class="level-item"><b-field><b-switch type="is-info" true-value="1" false-value="0" :left-label='true' v-model="behaviorData.status">{{ statusLabel(behaviorData.status) }}</b-switch></b-field></div>
                        </div>
                    </nav>
                </div>
            </div>
            <div class="columns">
                <div class="column is-6">
                    <b-field label="Item Name">
                        <b-input v-model="behaviorData.name"></b-input>
                    </b-field>
                    <div class="columns">
                        <div class="column is-3">
                            <b-field label="Points Weight" v-show="behaviorData.dataType != 3">
                                <b-input type="number" min="-100" max="100" v-model="behaviorData.points" style="width: 100px;"></b-input>
                            </b-field>
                        </div>
                        <div class="column">
                            <b-field label="Item Type">                                
                                <b-select id="newDataType" name="newDataType" v-model="newDataType" expanded>
                                    <option value="1">Normal</option>
                                    <option value="2">Attendance</option>
                                    <option value="4">Parent (only appear in Parent app)</option>
                                    <option value="5">Subject Attendance</option>
                                </b-select>
                            </b-field>
                        </div>
                    </div>
                    <div class="columns">
                        <div class="column is-7">
                            <b-field label="Limit Submission" v-model="behaviorData.points" v-show="(behaviorData.dataType == 1 || behaviorData.dataType == 4 || behaviorData.dataType == 5)">
                                <div class="columns">
                                    <div class="column is-5">
                                        <b-input type="number" min="-1" max="100" v-model="behaviorData.submissionLimit" style="width: 100px;" :disabled=isSubmissionLimitDisabled></b-input>
                                    </div>
                                    <div class="column is-7">
                                        <b-select id="submissionLimitType" name="submissionLimitType" v-model="behaviorData.submissionLimitType" @input="submissionLimitTypeDisplay()" style="margin-left: 5px;">
                                            <option value="1">By daily</option>
                                            <option value="2">By yearly</option>
                                            <option value="-1">NO Limit</option>
                                        </b-select>
                                    </div>
                                </div>
                            </b-field>
                        </div>
                        <div class="column is-5">
                            <b-field label="Linear Scale" v-model="behaviorData.points" v-show="(behaviorData.dataType == 1 || behaviorData.dataType == 4 || behaviorData.dataType == 5)">
                                <div class="columns">
                                    <div class="column is-3" style="margin-top: 7px;">
                                        1 to
                                    </div>
                                    <div class="column is-9">
                                        <b-input type="number" min="1" max="100" v-model="behaviorData.scaleLimit" />
                                    </div>
                                </div>
                            </b-field>
                        </div>
                    </div>
                </div>
                <div class="column is-6">
                    <b-field label="EXTRA INFORMATION (OPTIONAL)">
                        <b-input v-model="behaviorData.info"></b-input>
                    </b-field>
                    <b-field label="PERSON IN CHARGE (LEAVE BLANK IF AVAILABLE TO ALL)">
                        <multiselect v-model="behaviorData.restrictAwardTo" :options="listTeachers" :close-on-select="false" :multiple="true" :hide-selected="true" label="firstName" track-by="_id"></multiselect>
                    </b-field>
                    <b-field label="INCLUDE IN WHICH CATEGORY?">
                        <multiselect v-model="behaviorData.tags" :options="listTags" :close-on-select="false" :multiple="true" :hide-selected="true" label="name" track-by="_id" placeholder="Categories"></multiselect>
                    </b-field>
                    <div style="margin-start: 5px; margin-top: -10px; font-size: 12px; color: rgb(46, 142, 252); font-weight: bold;" v-on:click="goManageBehaviorTags()">Manage Category</div>
                </div>
                <!-- <div class="column is-3">                
                    <b-select id="restrictAwardBy" name="restrictAwardBy" v-model="behaviorData.restrictAwardBy" v-show="behaviorData.dataType != 4">
                        <option value="1">Used by everyone</option>
                        <option value="2">Used only by class/department teachers/supervisors</option>
                        <option value="3">Used only by selected teachers/supervisors</option>
                    </b-select>
                </div> -->
            </div>
            <div class="columns">
                <div class="column is-7">
                    <b-field label="CHOOSE THEME COLOUR">
                        <v-swatches v-model="behaviorData.colour" shapes="circles" :swatches="swatches" inline></v-swatches>
                    </b-field>
                </div>
                <div class="column is-5">
                    <!-- <b-tooltip label="If an item is set as mandatory, you will NOT BE ABLE TO do any submission unless you selected this item too">
                        <b-select id="isMandatory" name="isMandatory" v-model="behaviorData.isMandatory" style="width: 300px;" v-show="(behaviorData.dataType == 1 && behaviorData.restrictAwardBy == 1)">
                            <option value="0">Item is NOT mandatory</option>
                            <option value="1">Item IS MANDATORY for each submission</option>
                        </b-select>
                    </b-tooltip>
                    <div v-show="behaviorData.isMandatory == 1" style="color: red;">Take note that by selecting this, you will NOT BE ABLE TO do any submission unless you selected this item too</div> -->
                </div>
            </div>
            <div class="columns">
                <div class="column is-2" style="margin-top: 5px;">
                    <b-checkbox v-model="behaviorData.isRemarksMandatory"
                        name="isRemarksMandatory" true-value="1" false-value="0"
                        class="radio-label">
                        REMARKS IS COMPULSORY
                    </b-checkbox>
                </div>
                <div class="column is-2" style="margin-top: 5px;">
                    <b-checkbox v-model="behaviorData.sendNotification"
                        name="sendNotification" true-value="1" false-value="0"
                        class="radio-label">
                        NOTIFICATION TO PARENT APP
                    </b-checkbox>
                </div>
                <div class="column is-2" style="margin-top: 5px;" v-show="((behaviorData.dataType == 1) || (behaviorData.dataType == 2) || (behaviorData.dataType == 5))">
                    <b-checkbox v-model="behaviorData.enableFaceCapture"
                        name="enableFaceCapture" true-value="1" false-value="0"
                        native-value="1" class="radio-label" :disabled=isFaceCaptureDisabled>
                        FACE CAPTURE IN KIOSK MODE
                    </b-checkbox>
                </div>
                <div class="column is-2" style="margin-top: 5px;">
                    <b-checkbox v-model="behaviorData.enableLocation"
                        name="enableLocation" true-value="1" false-value="0"
                        native-value="1" class="radio-label" :disabled=isLocationDisabled>
                        LOCATION INFORMATION
                    </b-checkbox>
                </div>
                <div class="column is-3">
                    <b-button type="is-primary" v-on:click="updateData(behaviorData)" expanded>Update</b-button>
                </div>
                <div class="column is-1">
                    <b-button type="is-secondary" v-on:click="isComponentModalActive = false" expanded>X</b-button>
                </div>
            </div>
            <div class="columns" v-show="((schoolID == '6099e8d1e567ab06f84b8d17') || (schoolID == '5c1a735fc98da061141475a1'))"><!-- Only forPUNB -->
                <div class="column is-12">
                    <div>
                        <h3>Only for PUNB</h3>
                        <div class="field">
                            <label class="label">Make this item only Yes or No?</label>
                            <div class="control">
                                <label class="radio">
                                    <input type="radio" v-model="behaviorData.customBehaviorYesNo" value="1">
                                    Yes
                                </label>
                                <label class="radio">
                                    <input type="radio" v-model="behaviorData.customBehaviorYesNo" value="-1" checked>
                                    No
                                </label>
                            </div>
                        </div>
                        <div class="field">
                            <label class="label">Allow only numerics in remarks?</label>
                            <div class="control">
                                <label class="radio">
                                    <input type="radio" v-model="behaviorData.customBehaviorRemarksInt" value="1">
                                    Yes
                                </label>
                                <label class="radio">
                                    <input type="radio" v-model="behaviorData.customBehaviorRemarksInt" value="-1" checked>
                                    No
                                </label>
                            </div>
                        </div>
                        <div class="field">
                            <label class="label">Allow negative mutiplier?</label>
                            <div class="control">
                                <label class="radio">
                                    <input type="radio" v-model="behaviorData.customBehaviorNegativeMultiplier" value="1">
                                    Yes
                                </label>
                                <label class="radio">
                                    <input type="radio" v-model="behaviorData.customBehaviorNegativeMultiplier" value="-1" checked>
                                    No
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </b-modal>
</nav>
</template>

<script>
import Multiselect from 'vue-multiselect'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import VSwatches from 'vue-swatches'
import 'vue-swatches/dist/vue-swatches.css'
import axios from 'axios'
import { ToastProgrammatic as Toast } from 'buefy'

export default {
    props: ['behaviorData','listTeachers','listTags','dataIndex'],
    components:{
        Multiselect,
        Loading,
        VSwatches
    },
    data() {
        return {
            initialSelectedColour : "",
            newDataType: 1,
            schoolID: "",
            schoolPlan: 1,
            isEditing: false,
            isFaceCaptureDisabled: 0,
            isLocationDisabled: 0,
            currentLinkedTags: [],
            displayAdvanced: false,
            isComponentModalActive: false,            
            isSubmissionLimitDisabled: false,
            swatches: ['#1FBC9C', '#1CA085', '#2ECC70', '#27AF60', '#3398DB', '#2980B9', '#A463BF', '#8E43AD', '#3D556E', '#222F3D', '#F2C511', '#F39C19', '#E84B3C', '#C0382B', '#DDE6E8', '#BDC3C8' ]
        };
    },
    created() {
        this.initialSelectedColour = this.behaviorData.colour
        this.schoolID = localStorage.getItem('schoolID');
        this.schoolPlan = localStorage.getItem('plan')

        if (this.swatches.includes(this.behaviorData.colour)){
            console.log("color already in list, so no need to add")
        }else{
            this.swatches.push(this.behaviorData.colour)
        }

        if (this.schoolPlan == 1){
            this.isFaceCaptureDisabled = false
            this.isLocationDisabled = false
        }else{
            this.isFaceCaptureDisabled = true
            this.isLocationDisabled = true
        }
        this.newDataType = this.behaviorData.dataType
    },
    methods: {
        submissionLimitTypeDisplay(){
            if (this.behaviorData.submissionLimitType == "-1"){
                // this.behaviorData.submissionLimit = "-1"
                this.isSubmissionLimitDisabled = true;
            }else{
                this.isSubmissionLimitDisabled = false;
            }
        },
        statusLabel(status){
            if (status == "1"){
                return "ACTIVE"
            }else{
                return "INACTIVE"
            }
        },
        displayAdvancedProp(){
            if (this.displayAdvanced == true){
                this.displayAdvanced = false;
            }else{
                this.displayAdvanced = true;
            }
        },
        goManageBehaviorTags(){
            this.$router.push({
                name: "ManageBehaviorsTagsHome"
            });
        },
        displayDataType(dataType){
            if (dataType == 1){
                return "Normal"
            }else if (dataType == 2){
                return "Attendance"
            }else if (dataType == 3){
                return "Notification"
            }else if (dataType == 4){
                return "Parent App"
            }else if (dataType == 5){
                return "Subject Attendance"
            }
        },
        deleteData(data) {
            this.$emit('delete-data', data);
        },
        editData() {
            this.isEditing = true;
        },
        cancelEdit(){
            this.isEditing = false;
        },
        updateData(data) {
            data.initialSelectedColour = this.initialSelectedColour
            this.$emit('update-data', data,this.newDataType);
        },
        updateStatus(){
            axios.defaults.responseType = 'json'     
            axios.post(process.env.NEW_ENDPOINT + '/behaviors/updateStatus/', {
                token: localStorage.getItem('jwtTokenV2'),
                email: localStorage.getItem('email'),
                _id: this.behaviorData._id,
                status: this.behaviorData.status
            })
            .then(response => {
                if (response.data.success == false) {
                    Toast.open({
                        message: response.data.msg,
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 5000
                    })
                } else {
                    Toast.open({
                        color: 'is-dark', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        message: response.data.msg,
                        type: 'is-success',
                        duration: 3000
                    })
                }
            })
            .catch(e => {
                if (e.response.status === 401) {                            
                    Toast.open({
                        message: "Unauthorized access. Please re-login.",
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 5000
                    })
                } else {
                    Toast.open({
                        message: 'Error: ' + e.response.data.msg,
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 5000
                    })
                }
            })

        }
    },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.modalContents{
    background-color: #fff !important;
    padding: 20px;
    border-radius: 25px;
    overflow: hidden;
}
.level-item input{
    color: rgb(46, 142, 252);
}
.label{
    font-size: 13px !important;
    text-transform: uppercase !important;
}
input, select{
    color: rgb(46, 142, 252) !important;
}
.b-checkbox.checkbox input[type=checkbox] + .check {
  -ms-transform: scale(1) !important; /* IE */
  -moz-transform: scale(1) !important; /* FF */
  -webkit-transform: scale(1) !important; /* Safari and Chrome */
  -o-transform: scale(1) !important; /* Opera */
  transform: scale(0.9) !important;
  padding: 10px !important;
}
input[type=checkbox]
{
  /* Double-sized Checkboxes */
  -ms-transform: scale(1.5) !important; /* IE */
  -moz-transform: scale(1.5) !important; /* FF */
  -webkit-transform: scale(1.5) !important; /* Safari and Chrome */
  -o-transform: scale(1.5) !important; /* Opera */
  transform: scale(1.5) !important;
  padding: 10px !important;
}
.vue-swatches__swatch{
    margin-bottom: 10px !important;
}
.radio-label{
    font-size: 12.5px !important;
    color: rgb(46, 142, 252) !important;
}
.noborder tr td { border:none !important; }
</style>


// WEBPACK FOOTER //
// src/components/Manage/Behaviors/DataView.vue